module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Love At Mistletoe Inn: A December Wedding Story: A Year of Weddings Novella")]), _c('link', {
    attrs: {
      "href": "css/default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ser1"
  }, [_c('a', {
    attrs: {
      "href": "#/contents#bb_1",
      "id": "aa_1"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Chapter One",
      "id": "p0005-d6e10",
      "src": "images/9780310392187_Conten_0005_002.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "tx1p",
    attrs: {
      "id": "p0005-03-1"
    }
  }, [_c('i', [_vm._v("Although "), _c('a', {
    attrs: {
      "id": "page1"
    }
  }, [_vm._v("spending an entire Saturday manning a")])]), _c('a', {
    attrs: {
      "id": "page1"
    }
  }, [_vm._v(" booth at the Boise Bridal Extravaganza might not be most women’s idea of fun, Hope Prentiss was enjoying herself. It helped that Amity Carter had the next booth.")])]), _c('a', {
    attrs: {
      "id": "page1"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0005-03-3"
    }
  }, [_vm._v("While Hope was at the October event promoting Harmony Creek, a popular Idaho venue for weddings and receptions, Amity specialized in helping brides plan nontraditional weddings.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0005-03-4"
    }
  }, [_vm._v("Although both women were in their late twenties and were the best of friends, they couldn’t have been more different. How her friend had chosen to dress for today’s business event was a perfect example of her unorthodox approach. While Hope had picked black pants, a simple white shirt, and pulled her auburn hair back from her face with two silver clips, Amity breezed in looking like a windblown gypsy.")])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0005-03-6"
    }
  }, [_c('a', {
    attrs: {
      "id": "page1"
    }
  }, [_vm._v("She had disheveled dark curls tumbling down her back, a boho-chic dress of purple gauzy cotton, and gladiator sandals. Amity’s eyes were the color of exotic spices, and her ")]), _c('a', {
    attrs: {
      "id": "page2"
    }
  }, [_vm._v("effective use of makeup made her eyes the focal point of a striking face. Though Hope usually received compliments on her sea-green eyes, next to Amity she felt like a brown wren beside a bright peacock.")])]), _c('a', {
    attrs: {
      "id": "page2"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0006-02-2"
    }
  }, [_vm._v("Hope sighed when Amity handed her a cup of cappuccino “borrowed” from one of the vendors touting their mobile coffee bar.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0006-02-3"
    }
  }, [_vm._v("“I can’t believe we’re friends,” Hope murmured, bringing the cup to her lips.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0006-02-4"
    }
  }, [_vm._v("A sardonic smile lifted Amity’s lips. “Love ya too, Chickadee.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0006-02-5"
    }
  }, [_vm._v("Dragging her chair over to Hope’s booth, Amity settled in with her cup of gourmet hot cocoa. The fashion show was under way in another part of the Boise Centre, which gave the vendors a chance to relax.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0006-02-6"
    }
  }, [_vm._v("Hope took a long drink and let the caffeine jolt her mind. “I meant you’re adorable and so much fun.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0006-02-7"
    }
  }, [_vm._v("“All true.” Amity flashed a grin, then blew on the steaming cocoa. “Though I prefer mysterious to adorable.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0006-02-8"
    }
  }, [_vm._v("“You’re beautiful and mysterious while I’m average and forgettable.” Hope’s lips lifted in a self-deprecating smile.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0006-02-9"
    }
  }, [_vm._v("“Oh, I don’t know,” Amity drawled. “You have a few redeeming qualities. You’re a nice person. And a most excellent friend.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0006-02-10"
    }
  }, [_vm._v("“I’m not exactly spontaneous.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0006-02-11"
    }
  }, [_vm._v("“Are you referring to the incident last week when you refused to go to a concert with me so you could stay home and watch your pears grow?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0006-02-12"
    }
  }, [_vm._v("“I needed to "), _c('i', [_vm._v("pick")]), _vm._v(" pears,” Hope clarified. “Anyway, the cost of the ticket for that show was out of my price range.”")])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0007-01-0"
    }
  }, [_c('a', {
    attrs: {
      "id": "page2"
    }
  }), _c('a', {
    attrs: {
      "id": "page3"
    }
  }, [_vm._v("Amity’s eyes twinkled. “What range is that?”")])]), _c('a', {
    attrs: {
      "id": "page3"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0007-01-1"
    }
  }, [_vm._v("“You know. Under twenty.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0007-01-2"
    }
  }, [_vm._v("Amity’s laugh sounded like the tinkling of a hundred mini wedding bells. “Darlin’, those prices went out in the last century.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0007-01-3"
    }
  }, [_vm._v("“I believe in being careful with my money.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0007-01-4"
    }
  }, [_vm._v("“A word from the unwise to the wise.” Amity took another sip of cocoa. “Can’t take it with you.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0007-01-5"
    }
  }, [_vm._v("Hope lifted one shoulder in a slight shrug. Even after all these years, the memories of her parents arguing over money, the worry over almost losing the only home she’d known, remained with her. So she was conservative—being fiscally responsible wasn’t a crime. But she wouldn’t win this argument. Not with spendthrift Amity.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0007-01-6"
    }
  }, [_vm._v("“I brought you something.” Hope rummaged around and found the box she’d stashed under the table. “Asian pears from my aunt’s orchard.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0007-01-7"
    }
  }, [_vm._v("“These look fabulous. They almost make me forgive you for the concert thing.” Her friend snatched the box, mouthed a quick ‘thank you,’ then abruptly narrowed her gaze. “Are you still hanging with Chester the molester?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0007-01-8"
    }
  }, [_vm._v("“He’s not a molester and his name is Chet,” Hope reminded her friend for the zillionth time.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0007-01-9"
    }
  }, [_vm._v("Gold nails glimmered as Amity waved a dismissive hand. “Some names just seem to conjure up certain words. Hannah . . . banana. Fatty . . . Patty. Dirty . . . Debbie.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0007-01-11"
    }
  }, [_vm._v("“Hey, my mother’s name was Debbie.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0007-01-12"
    }
  }, [_vm._v("Amity only smirked. “Last, but certainly not least, Chester the molester.”")])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0007-01-13"
    }
  }, [_c('a', {
    attrs: {
      "id": "page3"
    }
  }, [_vm._v("“Chester, er, Chet Tuttle, is from one of the most ")]), _c('a', {
    attrs: {
      "id": "page4"
    }
  }, [_vm._v("prominent families in Harmony,” Hope said, alluding to the small town just outside Boise where they resided. “He’d never molest anybody. He’s as upright as they come. The guy has never even had a parking ticket.”")])]), _c('a', {
    attrs: {
      "id": "page4"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0008-02-2"
    }
  }, [_vm._v("“Am I supposed to applaud?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0008-02-3"
    }
  }, [_vm._v("Hope had to chuckle at her friend’s dry tone before her smile faded. “Chet would like for us to be exclusive. But I’m not ready to make that commitment to him.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0008-02-4"
    }
  }, [_vm._v("“Smart girl.” Amity nodded. “Why tie yourself to Mr. Super Boring?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0008-02-6"
    }
  }, [_vm._v("“Chet isn’t boring.” Hope rushed to defend the conservative banker. “He’s sensible.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0008-02-7"
    }
  }, [_vm._v("“A.k.a. bo-ring.” The response came in a singsong tone. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0008-02-8"
    }
  }, [_vm._v("Hope lifted her chin. “If he is, then I like boring.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0008-02-9"
    }
  }, [_vm._v("“Face it, Chickadee, you wouldn’t know how to handle a red-blooded male. Wouldn’t have a clue what to do with a real man.” Before Hope could protest, Amity jumped up as if the seat of her metal chair had suddenly turned red-hot. “Yikes! I just remembered I promised Sylvie in the Mad Batter booth I’d drop off a few of my business cards. Since she does nontrad stuff like me, she said she’d hand them out. Back in five.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0008-02-11"
    }
  }, [_vm._v("Hope had seen Sylvie’s cakes. They were definitely “nontrad.” The wedding cake displayed in the Mad Batter booth today was a perfect example. The multilayer concoction designed for a Christmas wedding sported red-and-white vertical stripes, black flowers, pearls, and . . . two prettily decorated fondant skulls. The words “’Til death us do part” flowed in elegant script across the front.")])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0008-02-12"
    }
  }, [_c('a', {
    attrs: {
      "id": "page4"
    }
  }, [_vm._v("While Hope thought the cake was more than a little ")]), _c('a', {
    attrs: {
      "id": "page5"
    }
  }, [_vm._v("creepy, Amity had squealed and raved. Hope liked to think she grounded Amity and made her fun-loving friend think twice before she jumped into some new venture.")])]), _c('a', {
    attrs: {
      "id": "page5"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0009-02-2"
    }
  }, [_vm._v("As for Amity, well, listening to her friend’s tales of exploits allowed Hope to live vicariously in a world she would never again embrace.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0009-02-3"
    }
  }, [_vm._v("Ten years ago Hope had ignored common sense and allowed herself to be swept from the safety of the shoreline into rocky waters where she was immediately in over her head. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0009-02-4"
    }
  }, [_vm._v("Amity was wrong. Even ten years ago, Hope had known what to do when she was confronted with a red-blooded male. She’d . . . married him.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0009-02-5"
    }
  }, [_vm._v("She’d been eighteen when she and John Burke had skipped their high-school prom and headed to Boise to elope. She couldn’t even console herself that it had been an impulsive, “hey, let’s get married tonight” kind of thing.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0009-02-6"
    }
  }, [_vm._v("They’d planned it out, getting a license and finding a minister to marry them. The preacher—and she used that term loosely, as the guy had been ordained online—had been in it for the cash.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0009-02-7"
    }
  }, [_vm._v("They’d said their vows, exchanged rings, and been pronounced husband and wife. Then the minister, “Buddy,” had demanded fifty dollars. John had balked, insisting they’d agreed on twenty and he didn’t have the extra thirty.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0009-02-8"
    }
  }, [_vm._v("A cold chill had traveled down her spine, just as it did now, remembering. Hope had been struck by the enormity of what she’d just done. She’d tied her future to someone who didn’t even have enough money to pay the preacher.")])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0009-02-9"
    }
  }, [_c('a', {
    attrs: {
      "id": "page5"
    }
  }, [_vm._v("Hope was embarrassed to recall how she’d fallen apart and cried like a baby, insisting she’d made a mistake and ")]), _c('a', {
    attrs: {
      "id": "page6"
    }
  }, [_vm._v("didn’t want to be married. John had tried to comfort and reassure her, but she’d been inconsolable.")])]), _c('a', {
    attrs: {
      "id": "page6"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0010-02-2"
    }
  }, [_vm._v("Buddy had taken pity on her. Though he was supposed to file the license within thirty days to make the marriage official, the college-student-turned-minister told her not to worry. He simply wouldn’t send in the forms. It’d be as if the marriage had never taken place.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0010-02-3"
    }
  }, [_vm._v("She and John returned to Harmony that night. On the ride back, John tried to talk to her, but she shut him out. For the next six weeks he tried repeatedly to breach the wall she’d erected.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0010-02-5"
    }
  }, [_vm._v("But when John gave up and hopped on his motorcycle the day after graduation to make his fortune, Hope felt as if her best friend had deserted her. Which made no sense at all. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0010-02-6"
    }
  }, [_vm._v("“Botheration!” The words came out on a groan.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0010-02-7"
    }
  }, [_vm._v("Hope blinked back to the present and realized the sound had come from Amity. “What’s the matter?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0010-02-8"
    }
  }, [_vm._v("“They’re coming this way,” Amity hissed.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0010-02-9"
    }
  }, [_vm._v("“Who?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0010-02-10"
    }
  }, [_vm._v("“Brooke Hauder and her mother.” Amity busied herself arranging brochures on her table, as if not making eye contact would cause the two to walk on by. “Brooke’s wedding plans are solid but she’s convinced something will go wrong. Crazy high-maintenance.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0010-02-12"
    }
  }, [_vm._v("The two women were definitely sauntering their direction. The girl was whippet-thin with a pale complexion common to gingers. The mother was short and stout and reminded Hope of a fireplug.")])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0010-02-13"
    }
  }, [_c('a', {
    attrs: {
      "id": "page6"
    }
  }, [_vm._v("Amity turned and offered a bright smile as the two ")]), _c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_vm._v("stopped in front of her booth. “Hey, gals. What brings you here today?”")])]), _c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0011-02-2"
    }
  }, [_vm._v("Hope knew she shouldn’t eavesdrop, but she couldn’t remember ever seeing Amity attempt to avoid speaking with someone. Crouching down, Hope pretended to be sorting through a box of pamphlets.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0011-02-3"
    }
  }, [_vm._v("The older woman placed a supportive hand on her daughter’s back. “Brooke has gotten herself all worked up over something. I hope speaking with you will reassure her.” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0011-02-4"
    }
  }, [_vm._v("“Of course.” Amity spoke in a surprisingly soothing tone. “What’s got you stressed, sweetie?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0011-02-5"
    }
  }, [_vm._v("The girl toyed with the button on her coat. “Mom thinks I’m being silly—”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Now, Brookie, I never said that.” The mother laughed lightly and shot Amity a conspiratorial glance.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0011-02-6"
    }
  }, [_vm._v("“You thought it.” The girl narrowed her eyes at her mother. “I know you—” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0011-P-1"
    }
  }, [_vm._v("“Tell me the problem.” Amity interrupted in a firm tone that silenced the two women.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0011-02-7"
    }
  }, [_vm._v("“It’s Pete’s uncle. The one who is going to marry us.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0011-02-8"
    }
  }, [_vm._v("From her vantage point, Hope could see Amity nod.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0011-02-9"
    }
  }, [_vm._v("“You know he’s not a real minister. I mean, he got ordained on one of those online sites, but he doesn’t have a church or anything.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0011-02-10"
    }
  }, [_vm._v("“I assure you, his online ordination means he can legally marry in the state of Idaho,” Amity said calmly.")])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0011-02-11"
    }
  }, [_c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_vm._v("“Pete and I were at his house last night. He said he hoped he didn’t forget to send in the marriage certificate after the ceremony because then we’d be living in sin. He laughed as if ")]), _c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_vm._v("it was some big joke. I told him he’d better not forget. Now I’m worried he will.”")])]), _c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0012-02-2"
    }
  }, [_vm._v("“He was teasing you, Brooke.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0012-02-3"
    }
  }, [_vm._v("Brooke continued as if her mother hadn’t spoken. “I told him if he didn’t send in those forms, Pete and I won’t be legally married.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0012-02-4"
    }
  }, [_vm._v("“And "), _c('i', [_vm._v("I")]), _vm._v(" told "), _c('i', [_vm._v("you")]), _vm._v(",” Mrs. Hauder interrupted, “that the marriage would still be legal.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0012-02-5"
    }
  }, [_vm._v("Hope’s knees began to tremble. She rested a hand on the nearby chair for support.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0012-02-6"
    }
  }, [_vm._v("“Your mother is correct,” Amity said to Brooke. “Even if the forms aren’t sent in, the marriage is legal.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0012-02-7"
    }
  }, [_vm._v("“Are you certain?” Brooke fixed her gaze on Amity.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0012-02-8"
    }
  }, [_vm._v("“One hundred percent positive. This issue has come up before. I verified it myself with the county recorder.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0012-02-9"
    }
  }, [_vm._v("“See, I told you.” The older woman’s tone turned chiding. “Do you ever listen to me? No.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0012-02-10"
    }
  }, [_vm._v("Cold fear stole Hope’s breath. As mother and daughter continued to bicker, a dull roaring filled her ears. She couldn’t move.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0012-02-11"
    }
  }, [_vm._v("“You can come out now,” Amity said good-naturedly. “Troll Bird and Spawn have departed.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0012-02-13"
    }
  }, [_vm._v("Slowly, Hope rose to her feet.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0012-02-14"
    }
  }, [_vm._v("“Did you ever hear anything so silly?” Amity chuckled and refilled the bowl on the vintage scale decorating her booth with more chocolate mints. “Thinking that just because the forms didn’t get sent the marriage wouldn’t be legal.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0012-02-15"
    }
  }, [_vm._v("A shaky laugh was all Hope could manage, while inside her thoughts raced.")])]), _c('p', {
    staticClass: "ser1"
  }, [_c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_c('img', {
    attrs: {
      "alt": "9780310392187_Conte_0013_001.jpg",
      "id": "p0013-d6e5",
      "src": "images/9780310392187_Conte_0013_001.jpg"
    }
  })]), _c('a', {
    attrs: {
      "id": "page9"
    }
  })]), _c('a', {
    attrs: {
      "id": "page9"
    }
  }, [_c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0013-02-0"
    }
  }, [_vm._v("On a sunny Saturday in early October, John Burke rode into Harmony on the back of his new Harley. The sights and smells of early autumn surrounded him. While most of the lawns were still green, the leaves had already morphed into vibrant shades of red and yellow and orange. There was a pleasant earthy fragrance to the air, as if it had recently rained. John inhaled deeply.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0013-02-1"
    }
  }, [_vm._v("He’d been back many times, but those had mostly been quick trips around the holidays. This was different.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0013-02-2"
    }
  }, [_vm._v("He reached the business district and continued to drive slowly, admiring the town square. A three-story stone city hall anchored the middle of the square, while shops lined the perimeter. Old-fashioned gas lamps stood like sentinels at the edge of the brick streets, ready to cast their light on the canopied storefronts.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0013-02-3"
    }
  }, [_vm._v("In no particular hurry, John circled the square several times, taking note of businesses that were new since his last visit. The names were displayed on colorful awnings over storefront windows: The Coffee Pot, Petal Creations, and Carly’s Cut and Curl. The only business not showing any action on a lazy Saturday afternoon was the Thirsty Buffalo, a popular local bar.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0013-02-4"
    }
  }, [_vm._v("Though John had loved working and living in Portland for the past ten years, Harmony was home. When he’d left after high school, he’d vowed to return when he was a success. ")])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0013-02-5"
    }
  }, [_c('a', {
    attrs: {
      "id": "page9"
    }
  }, [_vm._v("Against all odds, he’d reached that goal. But along that circuitous route with its peaks and valleys, John had discovered an undeniable truth. Success was more than a healthy bank account, more than following your passion; it was ")]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v("putting God and family first. Now he was coming home to put that belief into action.")])]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0014-02-2"
    }
  }, [_vm._v("John never knew his grandparents. His father had taken off when he was ten, shortly after his mother had been diagnosed with cancer. When he was sixteen, she’d died of the disease. The only family he had was Aunt Verna, who wasn’t really his aunt.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0014-02-3"
    }
  }, [_vm._v("Verna had been his mother’s childhood friend. When his mom passed away and John was tossed into the foster care system, Verna had taken classes to become a foster parent and brought him into her home. She was his family now. As she aged, he wanted to be there for her. But Verna wasn’t the only reason he’d returned to Harmony.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0014-02-4"
    }
  }, [_vm._v("John turned his cycle onto a brick street where older homes sat far back with huge expanses of lawns draped before them like green carpets. Except for one barking beagle and a boy on a bike, the neighborhood was quiet.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0014-02-5"
    }
  }, [_vm._v("At the far end of the road, he caught sight of his destination. The two-story home, with its wraparound porch, stained-glass window panels, and abundance of gingerbread molding, stood big and white against the brilliant blue of the sky. The ornate wrought-iron fence surrounding the main yard only added to its charm.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0014-02-6"
    }
  }, [_vm._v("Seeing it now, John was filled with a sense of coming home. He pulled the Harley into the drive. Almost immediately Verna appeared on the porch, a willowy woman with hair the color of champagne. When she raised her hand in greeting and he saw her broad smile, his fingers relaxed on the bike’s handlebar grips. He was home.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0014-02-7"
    }
  }, [_vm._v("This time for good.")])]), _c('p', {
    staticClass: "ser1"
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('img', {
    attrs: {
      "alt": "9780310392187_Conte_0013_001.jpg",
      "src": "images/9780310392187_Conte_0013_001.jpg"
    }
  })]), _c('a', {
    attrs: {
      "id": "page11"
    }
  })]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0015-P-1"
    }
  }, [_vm._v("Hope saw the motorcycle sitting in front of the carriage house when she pulled into the driveway. Idly, she wondered who Verna was showing through the barn. Though her aunt hadn’t had any late afternoon appointments scheduled when Hope left for the bridal fair that morning, it wasn’t unusual for prospective clients to drop by without an appointment.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0015-01-1"
    }
  }, [_vm._v("Despite Amity’s remarks looming over her like a dark cloud, Hope felt good about what she’d accomplished today. The booth had been worth every penny of the premium price they’d paid. Barn weddings were all the rage, and her booth displayed a slideshow of their gleaming red barn with its arched roof and remodeled interior. A number of brides and their mothers had set up times to visit Harmony Creek. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0015-01-3"
    }
  }, [_vm._v("After they’d torn down their booths, Amity had urged Hope to join her and some friends for dinner. But Hope was in no mood to socialize. Thankfully, Chet had called off their date for tonight. The man who would be his campaign manager had scheduled a meeting with business leaders about a possible state senate run.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0015-01-4"
    }
  }, [_vm._v("Just as well. Hope had too much on her mind, none of which she was ready to discuss with Amity or Chet.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0015-01-5"
    }
  }, [_c('i', [_vm._v("What if I am still married to John?")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0015-01-6"
    }
  }, [_vm._v("Hope stepped from the car, closing her eyes against the sudden stab in her heart. She knew God wouldn’t give her more than she could bear.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0015-01-7"
    }
  }, [_c('i', [_vm._v("It will be okay")]), _vm._v(", she told herself. "), _c('i', [_vm._v("It will all be okay")]), _vm._v(".")])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0015-01-8"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v("She entered the house, where she lived with her aunt, via ")]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v("the back door. Aunt Verna stood at the stove stirring a pot of soup and speaking with a man whose back was to Hope. He was tall and lanky, his wavy dark hair almost as long as hers. Hope had never seen her aunt cook in front of a potential client.")])]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0016-02-2"
    }
  }, [_vm._v("Obviously Verna knew this man and felt comfortable around him. Still, since her aunt seemed so determined to get dinner on the table, Hope would be a good niece and offer to show him around.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0016-02-3"
    }
  }, [_vm._v("Before she could make the offer, the man turned. Her heart dropped to her toes. She didn’t know whether to laugh hysterically or cry. Not more than she could bear? God apparently had more faith in her than was warranted.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0016-02-4"
    }
  }, [_vm._v("“Hello, Hope,” she heard John say. “It’s good to see you again.”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36d8e4d9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter1.vue
// module id = 69
// module chunks = 0